import React, { FC, useState } from 'react';
import CmsTableWithPrint from 'mixins/ui/cms-table-with-print/cms-table-with-print';
import CmsTable from '/react4xp/mixins/ui/cms-table';

const ServiceListPersonsTrResult: FC = (props: any) => {
    const [loading, setLoading] = useState(true);
    const [tableData, setTableData] = useState([]);
    const columns = [
        {
            title: props.config.taxOrgCode,
            dataIndex: 'region',
            key: 'region',
            width: 200,
        },
        {
            title: props.config.name,
            dataIndex: 'debtorName',
            key: 'debtorName',
            width: 200,
        },
        {
            title: props.config.taxpayerCode,
            dataIndex: 'taxpayerCode',
            key: 'taxpayerCode',
            width: 200,
        },
        {
            title: props.config.activity,
            dataIndex: 'activityRu',
            key: 'activityRu',
            width: 200,
        },
        {
            title: props.config.address,
            dataIndex: 'address',
            key: 'address',
            width: 200,
        },
        {
            title: props.config.directorName,
            dataIndex: 'directorFullName',
            key: 'directorFullName',
            width: 200,
        },
        {
            title: props.config.founderName,
            dataIndex: 'founderFullName',
            key: 'founderFullName',
            width: 200,
        },
        {
            title: props.config.procedureStartedIssueDate,
            dataIndex: 'procedureStartedIssueDate',
            key: 'procedureStartedIssueDate',
            width: 200,
        },
        {
            title: props.config.procedureStartedEntryForceDate,
            dataIndex: 'procedureStartedEntryForceDate',
            key: 'procedureStartedEntryForceDate',
            width: 200,
        },
        {
            title: props.config.procedureTerminatedIssueDate,
            dataIndex: 'procedureTerminatedIssueDate',
            key: 'procedureTerminatedIssueDate',
            width: 200,
        },
        {
            title: props.config.procedureTerminatedEntryForceDate,
            dataIndex: 'procedureTerminatedEntryForceDate',
            key: 'procedureTerminatedEntryForceDate',
            width: 200,
        },
    ];

    return (
        <>
            <CmsTableWithPrint
                columns={columns}
                data={props.data}
                isExportToCSV={true}
                exportToCSV={props.exportToCSV}
                downloading={props.downloading}
                params={props.params}
                apiUrl="/services/isnaportalsync/open-api/case-data-of-rehabilitation-which-is-terminated"
                translations={props.translations}
            />
        </>
    );
};

export default ServiceListPersonsTrResult;
